<ng-content *ngIf="isPage"></ng-content>


<!-- Formulario dinamico -->
<ng-container *ngIf="isAdd || isEdit">
    <div class="pt-10" fxLayout="row" fxLayoutAlign="end center">
        <button (click)="goBack()" mat-button fxLayout="row" fxLayoutAlign="end center" color="primary">
            <mat-icon color="primary">arrow_back</mat-icon>
            Regresar
        </button>
    </div>
    <seaged-form-factory [form]="form"
                         [idNegocio]="config?.metadataFormId" (onDoneForm)="onDoneForm($event)"></seaged-form-factory>
    <div class="pt-10" fxLayout="row" fxLayoutAlign="end center">
        <button [disabled]="!formValid" aria-label="SUBSCRIBE" (click)="onSave(form.value)"
                class="subscribe-button" color="accent"
                mat-raised-button>
            Guardar
        </button>
    </div>
</ng-container>
